var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.929 4.461H15.24V4.382C15.239 3.068 14.171 2 12.857 2H11.107C9.794 2 8.726 3.068 8.726 4.382V4.461H6.071C4.758 4.461 3.689 5.529 3.689 6.843V19.618C3.689 20.932 4.758 22 6.071 22H17.928C19.241 22 20.31 20.932 20.31 19.618V6.843C20.311 5.529 19.242 4.461 17.929 4.461ZM10.226 4.382C10.226 3.896 10.622 3.5 11.108 3.5H12.858C13.344 3.5 13.74 3.896 13.74 4.382V6.137H10.226V4.382ZM18.811 19.618C18.811 20.104 18.415 20.5 17.929 20.5H6.071C5.585 20.5 5.189 20.104 5.189 19.618V6.843C5.189 6.357 5.585 5.961 6.071 5.961H8.725V6.887C8.725 7.301 9.061 7.637 9.475 7.637H14.489C14.903 7.637 15.239 7.301 15.239 6.887V5.961H17.928C18.414 5.961 18.81 6.357 18.81 6.843V19.618H18.811Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.3136c1144ba52745015814504817caf8.svg";
export { ForwardRef as ReactComponent };